module.exports = __webpack_public_path__ + "img/南腔北调.860213aa.png";